import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/_dashboard/emails/organisations")({
  component: OrganisationEmailsComponent,
  loader: async () => ({
    crumb: "Organisations emails",
  }),
});

function OrganisationEmailsComponent() {
  const location = useRouterState({ select: (s) => s.location });
  const isOrganisationEmailsRoot = location.pathname === "/emails/organisations";

  return (
    <>
      {isOrganisationEmailsRoot && (
        <Card>
          <CardContent>
            <p className="text-md pb-20 pt-15 text-center">
              Please select an organisation from the submenu to view its email list.
            </p>
          </CardContent>
        </Card>
      )}
      <Outlet />
    </>
  );
}
